// extracted by mini-css-extract-plugin
export default {"progress":"progress-vNlKO","value":"value-xjfZw","withBorderRight":"withBorderRight-xrANQ"};